export default __webpack_public_path__ + "static/media/UserIcon.ea37c8ba.svg";